import { ApiData } from 'states/types'
import { AmenityBooking } from 'types/amenity-booking'

const Types = {
  SET: '@@amenity-booking/SET',
  ADD: '@@amenity-booking/ADD',
  UPDATE: '@@amenity-booking/UPDATE',
  LOADING: '@@amenity-booking/LOADING'
}

export type Payload = ApiData<AmenityBooking>

export { Types }
